module.exports = __webpack_public_path__ + "assets/img/android.a60dd9b1ec23c174b4d31e392b3726b1.svg";